var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.80005,
    y: 1.8,
    width: 19.2,
    height: 26.4,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.8C4 3.49218 7.49218 0 11.8 0H19C23.3078 0 26.8 3.49218 26.8 7.8V22.2C26.8 26.5078 23.3078 30 19 30H11.8C7.49218 30 4 26.5078 4 22.2V7.8ZM11.8 3.6C9.4804 3.6 7.6 5.4804 7.6 7.8V22.2C7.6 24.5196 9.4804 26.4 11.8 26.4H19C21.3196 26.4 23.2 24.5196 23.2 22.2V7.8C23.2 5.4804 21.3196 3.6 19 3.6H11.8Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3999 6.60001C10.2953 6.60001 9.3999 7.49544 9.3999 8.6V9.40001C9.3999 10.5046 10.2953 11.4 11.3999 11.4H19.3999C20.5045 11.4 21.3999 10.5046 21.3999 9.40001V8.60001C21.3999 7.49544 20.5045 6.60001 19.3999 6.60001H11.3999ZM11.4 15C10.2954 15 9.4 15.8954 9.4 17V17.8C9.4 18.9046 10.2954 19.8 11.4 19.8H14.6C15.7046 19.8 16.6 18.9046 16.6 17.8V17C16.6 15.8954 15.7046 15 14.6 15H11.4Z",
    fill: "#FFB6BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoc);
export default __webpack_public_path__ + "static/media/ic_doc.d894b37767b16fbea9a2cdc25be3d931.svg";
export { ForwardRef as ReactComponent };